export default {
  sm: `
    로보스테이션(ROBOSTATION), 사람과 로봇의 협업 데스크 사람과 로봇이 안전하게 협업할 수 있는 작업대입니다. 창고 내 자산 입반출을 로봇 간의 자동화에만 의존할 경우 특수 상황에 효율적으로 대응하기 어려울 수 있기 때문에, 사람과 자산관리 자동화 로봇 '세로'가 안전하게 협업할 수 있도록 만든 매개시설물입니다.
  `,
  xl: `
    로보스테이션(ROBOSTATION), 사람과 로봇의 협업 데스크 
    사람과 로봇이 안전하게 협업할 수 있는 작업대입니다. 창고 내 자산 
    입반출을 로봇 간의 자동화에만 의존할 경우 특수 상황에 효율적으로 
    대응하기 어려울 수 있기 때문에, 사람과 자산관리 자동화 로봇 '세로'가 안전하게 협업할 수 있도록 만든 매개시설물입니다.
  `,
};
